import { DatePipe } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ErrorHandler, Injector, NgModule, ModuleWithProviders } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
/* Authentication */
import { AuthGuard } from './auth/AuthGuard';
import { NumericKeyboard } from './components/numericKeyboard/numericKeyboard';
import { PeriodPicker } from './components/periodPicker/periodPicker';
import { T4Anchor } from './components/t4Anchor/t4Anchor';
import { T4Container } from './components/t4Container/t4Container';
import { t4Translation } from './components/t4tTranslation/t4Translation';
import { TimePickerComponent } from './components/timePicker/timePicker';
import { DatePickerDialog } from './dialogs/DatePickerDialog/DatePickerDialog';
import { PinDialog } from './dialogs/PinDialog/PinDialog';
import { PromptDialog } from './dialogs/promptDialog/promptDialog';
import { T4MessageBox } from './dialogs/t4MessageBox/t4messagebox';
import { RequireRoleDirective } from './Directives/RequireRoleDirective';
/* Other */
import { LocalStorage } from './LocalStorage';
import { CurrencyPipe, DecimalPipe, PercentPipe, TimePipe } from './pipes/number.pipe';
import { PickerModule } from '@ctrl/ngx-emoji-mart';
import { T4EmojiPickerComponent } from './components/emoji-picker/emoji-picker';
/* Pipes */
import { TranslatePipe } from './pipes/translation.pipe';
import { ServiceLocator } from './ServiceLocator';
import { ApiService } from './services/api.service';
import { AuthService } from './services/auth.service';
import { CacheService } from './services/cache.service';
import { InsightsService } from './services/insights.service';
/* Services */
import { SettingsService, T4Environment } from './services/settings.service';
import { TranslationService } from './services/translation.service';
import { UIService, UIServiceSettings } from './services/ui.service';
import { T4ErrorHandler } from './util/t4ErrorHandler';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { T4TurboOrderService, T4RentalLocationService, T4RentalObjectService, T4RentalService, T4CCService } from './models/services/Turbo.Data.Services';
import { RequireRightDirective } from './Directives/RequireRightDirective';
import { CustomerFormComponent } from './components/customerForm/customer-form';
import { TextFieldComponent } from './components/formTextField/text-field';
import { PhoneFieldComponent } from './components/formPhoneField/phone-field';
import { NotificationService } from './services/notification.service';
export function getWindow() { return window; }

@NgModule({
    declarations: [
        TranslatePipe,
        DecimalPipe,
        PercentPipe,
        CurrencyPipe,
        TimePipe,
        T4MessageBox,
        DatePickerDialog,
        PromptDialog,
        TimePickerComponent,
        PeriodPicker,
        t4Translation,
        T4Anchor,
        PinDialog,
    T4Container,
    T4EmojiPickerComponent,
        NumericKeyboard,
        RequireRoleDirective,
        RequireRightDirective,
        CustomerFormComponent,
        TextFieldComponent,
        PhoneFieldComponent
    ],
    imports: [BrowserModule,
        ReactiveFormsModule,
        FormsModule,
        RouterModule,
        MatDialogModule,
        MatDatepickerModule,
        MatProgressBarModule,
        MatIconModule,
        MatFormFieldModule,
        MatSelectModule,
        MatTooltipModule,
        MatInputModule,
        MatButtonModule,
        MatSnackBarModule,
      PickerModule
    ],
    providers: [
        SettingsService,
        ApiService,
        UIService,
        UIServiceSettings,
        AuthService,
        TranslationService,
        AuthGuard,
        LocalStorage,
        InsightsService,
        CacheService,
        TranslatePipe,
        DatePipe,
        DecimalPipe,
        PercentPipe,
        CurrencyPipe,
        TimePipe,
        T4TurboOrderService,
        T4RentalLocationService,
        T4RentalObjectService,
        T4RentalService,
      T4CCService,
        NotificationService,
      { provide: ErrorHandler, useClass: T4ErrorHandler },
      provideHttpClient(withInterceptorsFromDi())
    ],
    exports: [
        T4Anchor,
        TimePickerComponent,
        PeriodPicker,
        t4Translation,
        T4Container,
        T4MessageBox,
        DatePickerDialog,
        NumericKeyboard,
        TranslatePipe,
        DecimalPipe,
        PercentPipe,
        CurrencyPipe,
        PinDialog,
        RequireRoleDirective,
        RequireRightDirective,
      CustomerFormComponent,
      TextFieldComponent,
      T4EmojiPickerComponent
    ]
})
export class T4coreModule {

  private static mergedUISettings: UIServiceSettings = new UIServiceSettings();

  constructor(injector: Injector) {
    ServiceLocator.injector = injector;
  }

  public static forRoot(settings: UIServiceSettings): ModuleWithProviders<T4coreModule> {
    return {
      ngModule: T4coreModule,
      providers: [
        { provide: UIServiceSettings, useValue: T4coreModule.mergedUISettings}
      ]
    }
  }
}


